// extracted by css-extract-rspack-plugin
export default {"container":"_ab5a0585","title":"_ed7cca62"};